import { createMediaFileCall, updateMediaFileCall, deleteMediaFileCall, getMediaFilesByMetaCall, createMediaFileByUrlCall } from './apiCalls'
import authUser from './authUser'


const mediaFiles = {

    getToken() {
        return authUser.getToken()
    },

    createByUrl(movieTitle, fileType, fileUrl, callbackSuccess, callbackError) {
        const token = this.getToken()

        const data = {
            movie_title: movieTitle,
            image_type: fileType,
            image_url: fileUrl
        }

        createMediaFileByUrlCall(token, data)
            .then(response => {
                if(response && response.status && 201 === response.status && response.data) {
                    callbackSuccess(response.data)
                } else {
                    callbackError('Media upload error: Not 201 or no data')
                }
            })
            .catch(_ => {
                callbackError('Media upload error')
            })
    },

    create(file, fileName, callbackSuccess, callbackError) {
        const token = this.getToken()
        
        let formData = new FormData();
        formData.append('file', file)
        formData.append('title', fileName)

        createMediaFileCall(token, formData)
            .then(response => {
                if(response && response.status && 201 === response.status && response.data) {
                    callbackSuccess(response.data)
                } else {
                    callbackError('Media upload error: Not 201 or no data')
                }
                
            })
            .catch(_ => {
                callbackError('Media upload error')
            })
    },

    update(fileId, data, callbackSuccess, callbackError) {
        const token = this.getToken()

        updateMediaFileCall(token, fileId, data)
            .then(response => {
                if(response && response.status && 200 === response.status && response.data) {
                    callbackSuccess(response.data)
                } else {
                    callbackError('Media update error: Not 200 or no data')
                }
                
            })
            .catch(_ => {
                callbackError('Media update error')
            })
    },
 
    delete(fileId, callbackSuccess, callbackError) {
        const token = this.getToken()

        deleteMediaFileCall(token, fileId)
            .then(response => {
                if(response && response.status && 200 === response.status && response.statusText && 'OK' === response.statusText && response.data) { // Crap
                    callbackSuccess(response.data)
                } else {
                    callbackError('Media delete error: Not 200 or no data')
                }
                
            })
            .catch(error => {
                callbackError(error)
            })
    },

    getContentImages(callbackSuccess, callbackError, perPage, offset) {
        const token = this.getToken()

        getMediaFilesByMetaCall(token, 'content_image', 1, perPage, offset)
            .then(response => {
                if(response && response.status && 200 === response.status && response.statusText && 'OK' === response.statusText && response.data && response.headers) { // Crap
                    callbackSuccess(response.headers, response.data)
                } else {
                    callbackError('Media get error: Not 200 or no data or no headers')
                }
                
            })
            .catch(_ => {
                callbackError('Media get error')
            })
    }
}

export default mediaFiles